import moment from "moment";
import Button from "../../component-lib/Molecules/button/Button";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLoginUserId } from "../../utils/getToken";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import useSocketNotifications from "../../custom-hooks/UseSocketNotifications";
import { deleteNotification, patchVerifyOrder } from "./notificationSaga";
import { deleteIcon } from "../../assets";

interface NotificationItem {
  data: any;
  handleCheckboxChange: (data: any) => void;
}

const NotificationItem = ({ data, handleCheckboxChange }: NotificationItem) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const parseLoginUserId: any = getLoginUserId();
  const loginUserId = JSON.parse(parseLoginUserId);
  const { clearNotifications } = useSocketNotifications(loginUserId);

  // Generic, title-based navigation from a notification card.
  // - Group task ("New Group Task")  -> Tasks screen with the Group tab active
  // - Other task notifications        -> Tasks filtered to the current user
  // - Inventory / Low Stock           -> Inventory module
  // Order notifications keep their existing behaviour (Verify button) and do not navigate.
  const handleCardNavigation = () => {
    const title = (data?.notificationTitle || "").toLowerCase();
    if (title.includes("group task")) {
      navigate("/tasks", { state: { view: "Group" } });
    } else if (title.includes("task")) {
      navigate("/tasks", { state: { assignedToMe: true } });
    } else if (title.includes("inventory") || title.includes("stock")) {
      navigate("/inventory-management");
    }
  };

  // Some notifications (e.g. inventory uploads) send a JSON payload as the body
  // instead of plain text. Show the human-readable `message` from it; fall back
  // to the raw text for normal notifications.
  const getNotificationBody = (body: any) => {
    if (typeof body !== "string") return body;
    const trimmed = body.trim();
    if (!trimmed.startsWith("{")) return body;
    try {
      const parsed = JSON.parse(trimmed);
      return parsed?.message || body;
    } catch {
      return body;
    }
  };

  const handleVerifyOrder = (orderId: any) => {
    if (orderId) {
      const apiPayload = {
        payload: {
          status: "Verified",
        },
        orderId: orderId,
        clearNotifications,
      };

      dispatch(patchVerifyOrder(apiPayload));
    }
  };

  const handleDelete = (id: any) => {
    const payload = {
      id: id,
      clearNotifications,
    };
    dispatch(deleteNotification(payload));
  };

  return (
    <div
      className="flex justify-between rounded-md h-auto mb-6 group cursor-pointer"
      style={{ backgroundColor: "#F8F8F8" }}
      onClick={handleCardNavigation}
    >
      {/* <div
                      className="w-[6px] h-[95px] rounded-br-[24px] rounded-tr-[26px]"
                      style={{ backgroundColor: "#005596" }}
                    ></div> */}
      <div className="flex">
        <div
          className="w-[6px]  rounded-br-[24px] rounded-tr-[26px]"
          style={{ backgroundColor: "#005596" }}
        ></div>
        <div className="m-4 justify-center pr-2">
          {/* <EventEHRCheckbox
            label={data.name}
            checkboxSelected={data?.checkbox}
            callback={() => {
              handleCheckboxChange(data);
            }}
            customLabelStyle={{
              fontSize: "1rem",
              whiteSpace: "nowrap",
              color: "#393939",
              fontWeight: 600,
            }}
          /> */}
          <Heading
            title={data.name}
            customStyle={{
              fontSize: "1rem",
              whiteSpace: "nowrap",
              color: "#393939",
              fontWeight: 600,
            }}
          />
        </div>
        <div className="mt-5 mb-5 gap-2 flex flex-col pr-2">
          <span className="text-sm text-[#565656] font-medium">
            {data?.notificationTitle}
          </span>
          <span className="text-sm text-[#727272] font-medium">
            {getNotificationBody(data?.par)}
          </span>
          {data?.status && (
            <Button
              disabled={data?.status === "Verified"}
              label={data?.status === "Verified" ? "Verified" : "Verify"}
              variant="contained"
              onClickCb={(e: any) => {
                e?.stopPropagation?.();
                handleVerifyOrder(data?.orderId);
              }}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginTop: "10px",
              }}
            ></Button>
          )}
        </div>
      </div>

      <div className="mr-2 p-3.5 text-sm pr-2  flex justify-center flex-col items-center gap-2">
        <span className="text-[#BCBCBC] text-nowrap font-normal">
          {data?.time ? moment(data?.time).format("HH:mm") : ""}
        </span>
        <div
          className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(data?.id);
          }}
        >
          <img src={deleteIcon} alt="delete" />
        </div>{" "}
      </div>
    </div>
  );
};

export default NotificationItem;
